module.exports = __webpack_public_path__ + "img/bg.1da31477.svg";